import styles from './BetaBadge.module.css';

// The one "BETA" pill, so every beta surface (account menu, page menu, header
// trigger, analysis toolbar) reads the same. `className` is for contextual
// spacing only — the look stays here.
export default function BetaBadge({ className = '' }) {
  return <b className={`${styles.betaBadge} ${className}`.trim()}>BETA</b>;
}
